import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripTags',
  standalone: false
})
export class StripTagsPipe implements PipeTransform {
  transform(str?: string | null): string {
    return str?.replace(/<\/?[^>]+(>|$)/g, '') ?? '';
  }
}
